import React from "react";
import { graphql } from "gatsby";

import Layout from "../components/layout";
import Banner from "../components/contentfulModal/banner";
import GoalTrackerBanner from "../components/contentfulModal/goalTrackerBanner";
import CardList from "../components/contentfulModal/cardList";
import BannerList from "../components/contentfulModal/bannerList";
import CardGallery from "../components/contentfulModal/gallery";
import Images from "../components/contentfulModal/images";
import RichTextComponent from "../components/contentfulModal/richTextComponent";
import VideoModal from "../components/contentfulModal/videoModal";
import JobAdderWidget from "../components/contentfulModal/jobAdderWidget";
import useRokt from "../hooks/useRokt";
import CampaignForm from "../components/form/campaignForm";
import useClientSide from "../hooks/useClientSide";
import SubscriptionWidget from "../components/contentfulModal/subscriptionWidget";
import Seo from "../components/seo";
import useHandlePaypalUpdate from "../hooks/useHandlePaypalUpdate";
import useHandleCreditCardUpdate from "../hooks/useHandleCreditCardUpdate";
import useHandleApplePayUpdate from "../hooks/useHandleApplePayUpdate";
import StarShooting from "../components/motion/StarShooting";

const ContentPage = (props) => {
  const {
    data: {
      contentfulContentPage: {
        // name,
        // title,
        parentPages,
        hideBreadcrumb,
        headerBanner,
        goalTrackerBanner,
        firstOptionalRichText,
        firstOptionalImage,
        secondOptionalRichText,
        secondOptionalImage,
        thirdOptionalRichText,
        topRichText,
        video,
        middleRichText,
        middleOptionalImage,
        topCardList,
        topBannerList,
        bottomRichText,
        thirdOptionalImage,
        middleCardList,
        cardGallery,
        footerBanner,
        footerCardList,
        subscriptionWidget,

        campaignToDonationLink, //base link for redirect to a campaign
        cosmosCampaignId, //one of the link attribute for redirect to a campaign

        donationForm, //form group
        arrowIcon, //form group to display an Icon on the end, recommend remove it and hard code.
        donationBottomButton, //button text use in a rich text field for redirect to a campaign

        //for donationForm
        isCampaign, //not used anymore always extect this is true in ContentPage
        donationTopButton, //submission button text
        donationPageAnchor, //submission button link anchor

        triggerRokt,
        jobAdder,
      },
    },
    location,
  } = props;
  useRokt(triggerRokt);

  //   useEffect(() => eventPageLoad(name), [name]);
  // console.log(props, location);
  // console.log("pathname", location.pathname);

  const isClientSide = useClientSide();
  useHandlePaypalUpdate(isClientSide);
  useHandleCreditCardUpdate(isClientSide);
  useHandleApplePayUpdate(isClientSide);
  if (!isClientSide) {
    return null;
  }

  const breadcrumbSettings = {
    parentPages: parentPages,
    hideBreadcrumb: hideBreadcrumb ?? true,
  }

  return (
    <Layout campaignToDonationLink={campaignToDonationLink} cosmosCampaignId={cosmosCampaignId}>
      {location.pathname.includes("/thank-you") ? <StarShooting />:null}
      {headerBanner && !goalTrackerBanner ? <Banner bannerData={headerBanner} forceH1={true} breadcrumbSettings={breadcrumbSettings} /> : ""}
      {goalTrackerBanner ? <GoalTrackerBanner bannerData={goalTrackerBanner} forceH1={true} breadcrumbSettings={breadcrumbSettings}/> : ""}
      {topRichText ? <RichTextComponent data={topRichText} /> : ""}
      {video ? <VideoModal video={video} /> : ""}
      {firstOptionalRichText ? <RichTextComponent data={firstOptionalRichText} /> : ""}
      {firstOptionalImage ? <Images imagesList={firstOptionalImage} /> : ""}
      {secondOptionalRichText ? <RichTextComponent data={secondOptionalRichText} /> : ""}
      {secondOptionalImage ? <Images imagesList={secondOptionalImage} /> : ""}
      {thirdOptionalRichText ? <RichTextComponent data={thirdOptionalRichText} /> : ""}
      {donationForm ? (
        <CampaignForm
          formGroups={donationForm}
          arrowIcon={arrowIcon} //for rendering an arrow on right of top richText
          campaignToDonationLink={campaignToDonationLink} //for button
          donationTopButton={donationTopButton} //for button
          donationPageAnchor={donationPageAnchor} //for button
          cosmosCampaignId={cosmosCampaignId} //for button
        />
      ) : (
        ""
      )}
      {middleRichText ? <RichTextComponent data={middleRichText} /> : ""}
      {middleOptionalImage ? <Images imagesList={middleOptionalImage} /> : ""}
      {topCardList ? <CardList cardList={topCardList} /> : ""}
      {topBannerList ? <BannerList bannerListData={topBannerList} /> : ""}
      {subscriptionWidget ? <SubscriptionWidget widgetData={subscriptionWidget} /> : ""}
      {bottomRichText ? (
        <RichTextComponent
          data={bottomRichText}
          isCampaign={isCampaign} //for rendering a campaign redirect button
          campaignToDonationLink={campaignToDonationLink} //for button
          donationBottomButton={donationBottomButton} //for button
          cosmosCampaignId={cosmosCampaignId} //for button
        />
      ) : null}
      {thirdOptionalImage ? <Images imagesList={thirdOptionalImage} /> : ""}
      {middleCardList ? <CardList cardList={middleCardList} /> : ""}
      {cardGallery ? <CardGallery gallery={cardGallery} /> : ""}
      {jobAdder || false ? <JobAdderWidget jobAdder={jobAdder} location={location} /> : ""}
      {footerBanner ? <Banner bannerData={footerBanner} /> : ""}
      {footerCardList ? <CardList cardList={footerCardList} /> : ""}
    </Layout>
  );
};

export default ContentPage;

export const Head = ({
  data: {
    contentfulContentPage: { title, slug },
  },
}) => {
  return <Seo title={title} slug={slug}/>;
};

export const pageQuery = graphql`
  query ($slug: String!) {
    contentfulContentPage(slug: { eq: $slug }) {
      name
      slug
      title
      parentPages {
        title
        slug
      }
      hideBreadcrumb

      triggerRokt
      jobAdder
      donationBottomButton
      campaignToDonationLink
      cosmosCampaignId
      isCampaign
      arrowIcon {
        file {
          url
        }
      }
      donationTopButton
      donationPageAnchor
      donationForm {
        ...CampaignFormGroup
      }

      headerBanner {
        ...Banner
      }
      goalTrackerBanner {
        ...GoalTrackerBanner
      }
      topRichText {
        ...RichTextComponent
      }
      firstOptionalRichText {
        ...RichTextComponent
      }
      firstOptionalImage {
        ...Images
      }
      secondOptionalRichText {
        ...RichTextComponent
      }
      secondOptionalImage {
        ...Images
      }
      thirdOptionalRichText {
        ...RichTextComponent
      }
      thirdOptionalImage {
        ...Images
      }
      video {
        ...VideoModal
      }
      middleRichText {
        ...RichTextComponent
      }
      middleOptionalImage {
        ...Images
      }
      topCardList {
        ...CardList
      }
      topBannerList {
        ...BannerList
      }
      subscriptionWidget {
        ...SubscriptionWidget
      }
      bottomRichText {
        ...RichTextComponent
      }
      middleCardList {
        ...CardList
      }
      cardGallery {
        ...Gallery
      }
      footerBanner {
        ...Banner
      }
      footerCardList {
        ...CardList
      }
    }
  }
`;
